import React from "react";
import { Game } from "./game";

export interface Achievement {
  id: number;
  name: string;
  description?: string;
  additionalEffect?: string;
}

//ideas
// max first speed upgrade
//max all speed upgrades
// first molecule
//Avatar molecule stuff (fire, air, etc.)
// Buy first multiple molecule
// reach x particles without manually purchasing producers
//all collectors
//all auto buyers
//buy 99 super ai

//effect ideas
//make autobuyer faster
//Molecules like Carbon are first available after specific achievement
export const achievements: Achievement[] = [
  {
    id: 1,
    name: "A new beginning",
    description: "Buy a single Neutron",
  },
  {
    id: 2,
    name: "Atomic Overlord",
    description: "Buy a single Atom",
  },
  {
    id: 3,
    name: "Microbot Master",
    description: "Buy a single Microbot",
  },
  {
    id: 4,
    name: "Better weak than nothing",
    description: "Buy a single Weak AI",
  },
  {
    id: 5,
    name: "Nanobot Ninja",
    description: "Buy a single Nanobot",
  },
  {
    id: 6,
    name: "Weak*2 = Strong?",
    description: "Buy a single Strong AI",
  },
  {
    id: 7,
    name: "Even more Producers?",
    description: "Buy a single Quantum Assembler",
  },
  {
    id: 8,
    name: "Superman! uh Super AI!",
    description: "Buy a single Super AI",
  },
  {
    id: 11,
    name: "Collect them all!",
    description: "Have all producers collectable at the same time",
    additionalEffect: "Make Achievement Multiplier better",
  },
  {
    id: 12,
    name: "S-S-S-Strength!",
    description: "Producer Strengthening 4 times",
    additionalEffect: "Boost Producer also when 100 are purchased",
  },
  {
    id: 10,
    name: "Gotta go fast!",
    description: "Buy your first Speed Upgrade",
  },
  {
    id: 15,
    name: "Hire hypnofox",
    description: "Buy all Collectors",
  },
  {
    id: 13,
    name: "Why you should do this?",
    description: "Have over 1e55 Particles",
    additionalEffect:
      "Keep your Automator and Speed-Shop Upgrades on Molecule Reset",
  },
  {
    id: 14,
    name: "Chemie Expert",
    description: "Have Oxygen and Hydrogen purchased",
    additionalEffect: "Unlock Carbon",
  },
  {
    id: 16,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 17,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 18,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 19,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 9,
    name: "Is this the 9th Dimensions?",
    description: "Buy a single Quantum Engineer",
  },
  {
    id: 20,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 21,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 22,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 23,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 24,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 25,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 26,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 27,
    name: "Placeholder",
    description: "Placeholder",
  },
  {
    id: 28,
    name: "Placeholder",
    description: "Placeholder",
  },
];

export function unlockAchievement(
  id: number,
  unlockedAchievementIds: Set<number>,
  setGame: React.Dispatch<React.SetStateAction<Game>>
) {
  if (unlockedAchievementIds.has(id)) {
    return false;
  } else {
    setGame((prev) => {
      return {
        ...prev,
        unlockedAchievementIds: new Set(prev.unlockedAchievementIds.add(id)),
      };
    });
    return true;
  }
}

export function isAchievementUnlocked(
  id: number,
  unlockedAchievementIds: Set<number>
) {
  return unlockedAchievementIds.has(id);
}

export function getAchievementById(id: number) {
  return achievements.find((achievement) => achievement.id === id);
}
